let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ieMKQ")).then(() => parcelRequire('aUjws'));